// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1atWn","info":"PatientInfo_info__2E23E"};